import { useFormContext, useWatch } from 'react-hook-form'
import { SelectComponent } from '../../../../components/Form/Select'
import { useEffect } from 'react'

export function ClassificacaoICMS() {
  const {
    control,
    formState: { errors },
    setValue,
  } = useFormContext()

  const cnpjCpf = useWatch({ name: 'cnpjCpf' })

  const replacedCnpjCpf = cnpjCpf?.replace(/\D/g, '')

  const stateRegistration = useWatch({ name: 'stateRegistration' })
  const ICMS = useWatch({ name: 'icmsClassification' })

  console.log(stateRegistration)

  useEffect(() => {
    //see for IE ISENTO, is not contribuinte
    if (stateRegistration === 'ISENTO') {
      setValue('icmsClassification', { value: 'X', label: 'Não contribuinte' })
    } else {
      setValue('icmsClassification', { value: 'C', label: 'Contribuinte' })
    }

    //se for cpf, é isento e não contribuinte
    if (!ICMS && replacedCnpjCpf?.length === 11) {
      setValue('icmsClassification', { value: 'X', label: 'Não contribuinte' })
      setValue('stateRegistration', 'ISENTO')
    }

    if (ICMS === 'Verificar') {
      setValue('icmsClassification', { value: 'VERIFICAR', label: 'VERIFICAR' })
    }
  }, [replacedCnpjCpf, setValue, stateRegistration])

  return (
    <SelectComponent
      width="100%"
      label="Classificação ICMS"
      control={control}
      name="icmsClassification"
      options={[
        { value: 'VERIFICAR', label: 'VERIFICAR' },
        { value: 'C', label: 'Contribuinte' },
        { value: 'X', label: 'Não contribuinte' },
      ]}
      error={errors.icmsClassification}
      isDisabled
    />
  )
}
